module.exports = __webpack_public_path__ + "media/Video 97.7a46afcb.mp4";